import {all, call, put, takeEvery} from 'redux-saga/effects'
import {
  CommentsActionTypes,
  fetchError,
  fetchSuccess,
  updateSuccess,
  updateError
} from '@actions/comment';
import commentApi from '@api/comment'
import {ReduxAction} from "@actions/index";

function* handleFetch({payload}: ReduxAction) {
  try {
    const res = yield call(commentApi.getList, payload);
    yield put(fetchSuccess(res))
  } catch (err) {
    yield put(fetchError(err.stack!))
  }
}

function* handleUpdate({payload}: ReduxAction) {
  try {
    const {data} = yield call(commentApi.update, payload);
    payload.onSuccessCallback && payload.onSuccessCallback();
    yield put(updateSuccess(data))
  } catch (err) {
    yield put(updateError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}

// We can also use `fork()` here to split our saga into multiple watchers.
function* commentsSaga() {
  yield all([
    yield takeEvery(CommentsActionTypes.FETCH_REQUEST, handleFetch),
    yield takeEvery(CommentsActionTypes.UPDATE_REQUEST, handleUpdate)
  ])
}

export default commentsSaga;
